/**
 * VisitMemberEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { VisitEntity } from "../VisitEntity";
import { PersonEntity } from "../PersonEntity";
import { VisitMemberEntity } from "../VisitMemberEntity";
declare global {
    interface EntityTypeMap {
        VisitMember: VisitMemberEntity;
    }
}
export abstract class VisitMemberGeneratedEntity extends BaseEntity {
    public abstract visitMemberId: string;
    public abstract templateId: string | null;
    public abstract presenceType: number | null;
    public abstract isConvoked: boolean | null;
    public abstract type: string | null;
    public abstract order: number | null;
    public abstract convokedOn: Date | null;
    public abstract penalty: number | null;
    public abstract absenceResetCount: number | null;
    public abstract lateResetCount: number | null;
    public abstract excusedResetCount: number | null;
    public abstract presenceResetCount: number | null;
    public abstract visit: VisitEntity;
    public abstract person: PersonEntity | null;
}
